import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vuetify from 'vuetify'
import VueCookies from 'vue-cookies'

import GetpolisConstants from "./plugins/GetpolisConstants";
import MultiFiltersPlugin from './plugins/MultiFilters'

// Helpers
import colors from 'vuetify/es5/util/colors'

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue';
window.Vue = Vue;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.use(Vuetify, {
    theme: {
        primary: '#00ba57',
        secondary: '#00ba57',
        accent: '#00ba57'
    },
    iconfont: 'md'
});

Vue.use(VueCookies);
VueCookies.config('30d');

Vue.use(GetpolisConstants);
Vue.use(MultiFiltersPlugin);

import HeaderComponent from './components/elements/HeaderComponent.vue';
import NewsPage from './components/pages/NewsPage.vue';
import NewsArticlePage from './components/pages/NewsArticlePage.vue';

Vue.component('header-component', HeaderComponent);
Vue.component('news-page', NewsPage);
Vue.component('news-article-page', NewsArticlePage);

const app = new Vue({
    el: '#app'
});





// WEBPACK FOOTER //
// ./resources/js/news.js